module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "block_11"
  }, [_c('i', {
    staticClass: "calibre1"
  }), _c('i', {
    staticClass: "calibre1",
    attrs: {
      "id": "id_toc"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "block_12"
  }, [_c('a', {
    staticClass: "text_",
    attrs: {
      "href": "#/index_split_007#id_Toc100507708"
    }
  }, [_vm._v("Prologue")])]), _vm._v(" "), _c('p', {
    staticClass: "block_12"
  }, [_c('a', {
    staticClass: "text_",
    attrs: {
      "href": "#/index_split_008#id_Toc100507709"
    }
  }, [_vm._v("Chapter 1")])]), _vm._v(" "), _c('p', {
    staticClass: "block_12"
  }, [_c('span', {
    staticClass: "text_",
    attrs: {
      "href": "#/index_split_009#id_Toc100507710",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 2")])]), _vm._v(" "), _c('p', {
    staticClass: "block_12"
  }, [_c('span', {
    staticClass: "text_",
    attrs: {
      "href": "#/index_split_010#id_Toc100507711",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 3")])]), _vm._v(" "), _c('p', {
    staticClass: "block_12"
  }, [_c('span', {
    staticClass: "text_",
    attrs: {
      "href": "#/index_split_011#id_Toc100507712",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 4")])]), _vm._v(" "), _c('p', {
    staticClass: "block_12"
  }, [_c('span', {
    staticClass: "text_",
    attrs: {
      "href": "#/index_split_012#id_Toc100507713",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 5")])]), _vm._v(" "), _c('p', {
    staticClass: "block_12"
  }, [_c('span', {
    staticClass: "text_",
    attrs: {
      "href": "#/index_split_013#id_Toc100507714",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 6")])]), _vm._v(" "), _c('p', {
    staticClass: "block_12"
  }, [_c('span', {
    staticClass: "text_",
    attrs: {
      "href": "#/index_split_014#id_Toc100507715",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 7")])]), _vm._v(" "), _c('p', {
    staticClass: "block_12"
  }, [_c('span', {
    staticClass: "text_",
    attrs: {
      "href": "#/index_split_015#id_Toc100507716",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 8")])]), _vm._v(" "), _c('p', {
    staticClass: "block_12"
  }, [_c('span', {
    staticClass: "text_",
    attrs: {
      "href": "#/index_split_016#id_Toc100507717",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 9")])]), _vm._v(" "), _c('p', {
    staticClass: "block_12"
  }, [_c('span', {
    staticClass: "text_",
    attrs: {
      "href": "#/index_split_017#id_Toc100507718",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 10")])]), _vm._v(" "), _c('p', {
    staticClass: "block_12"
  }, [_c('span', {
    staticClass: "text_",
    attrs: {
      "href": "#/index_split_018#id_Toc100507719",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 11")])]), _vm._v(" "), _c('p', {
    staticClass: "block_12"
  }, [_c('span', {
    staticClass: "text_",
    attrs: {
      "href": "#/index_split_019#id_Toc100507720",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 12")])]), _vm._v(" "), _c('p', {
    staticClass: "block_12"
  }, [_c('span', {
    staticClass: "text_",
    attrs: {
      "href": "#/index_split_020#id_Toc100507721",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 13")])]), _vm._v(" "), _c('p', {
    staticClass: "block_12"
  }, [_c('span', {
    staticClass: "text_",
    attrs: {
      "href": "#/index_split_021#id_Toc100507722",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 14")])]), _vm._v(" "), _c('p', {
    staticClass: "block_12"
  }, [_c('span', {
    staticClass: "text_",
    attrs: {
      "href": "#/index_split_022#id_Toc100507723",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 15")])]), _vm._v(" "), _c('p', {
    staticClass: "block_12"
  }, [_c('span', {
    staticClass: "text_",
    attrs: {
      "href": "#/index_split_023#id_Toc100507724",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Epilogue")])]), _vm._v(" "), _c('p', {
    staticClass: "block_12"
  }, [_c('span', {
    staticClass: "text_",
    attrs: {
      "href": "#/index_split_024#id_Toc100507725",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Author’s Note")])]), _vm._v(" "), _c('p', {
    staticClass: "block_12"
  }, [_c('span', {
    staticClass: "text_",
    attrs: {
      "href": "#/index_split_025#id_Toc100507726",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])]), _vm._v(" "), _c('p', {
    staticClass: "block_12"
  }, [_c('span', {
    staticClass: "text_",
    attrs: {
      "href": "#/index_split_026#id_Toc100507727",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Sneak Peek of LITTLE DOES SHE KNOW")])]), _vm._v(" "), _c('p', {
    staticClass: "block_12"
  }, [_c('span', {
    staticClass: "text_",
    attrs: {
      "href": "#/index_split_026#id_Toc100507728",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 1: Ginger Mallowan")])]), _vm._v(" "), _c('p', {
    staticClass: "block_12"
  }, [_c('span', {
    staticClass: "text_",
    attrs: {
      "href": "#/index_split_027#id_Toc100507729",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("LITTLE DOES SHE KNOW")])]), _vm._v(" "), _c('p', {
    staticClass: "block_13"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_14",
    attrs: {
      "id": "calibre_pb_4"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-608d0260","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/index_split_004.vue
// module id = 69
// module chunks = 0